import { BaseApiService } from '../../common/services/baseApiService';
import { API_URL } from '../../common/utils/util';
import { ImportDefaults, ImportReport } from '../types/users.types';

export class UsersImportService extends BaseApiService {
  /** Dry-run: valida el CSV. El backend NO escribe nada. */
  static async validate(
    csv: string,
    defaults: ImportDefaults,
  ): Promise<ImportReport> {
    const response = await fetch(`${API_URL}/users/import/validate`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify({ csv, defaults }),
    });
    return this.handleResponse<ImportReport>(response);
  }

  /** Ejecuta la importacion. Idempotente: los emails existentes se omiten. */
  static async run(
    csv: string,
    defaults: ImportDefaults,
  ): Promise<ImportReport> {
    const response = await fetch(`${API_URL}/users/import`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify({ csv, defaults }),
    });
    return this.handleResponse<ImportReport>(response);
  }
}
